export type IHandleValidation = IDCA.IGenericFunc;

export function handleValidation() {
  // for more info visit the official plugin documentation:
  // http:// docs.jquery.com/Plugins/Validation
  const $forms = $('form[name="dexerofd-form"]:not(.special-form-validation)');
  const getElementName = (elm: IjQueryElmOrHtmlElm) => {
    const $elm = $(elm);
    let elementName = $elm.attr('name') || '';
    if ($elm.hasClass('special-validation-input')) {
      elementName = elementName.replace('_specialValidationInput', '');
    } else if (elementName.startsWith('auto_')) {
      elementName = elementName.replace('auto_', '');
    }
    return elementName;
  };

  $forms.each(function each() {
    // attach to all form elements on page
    const options = window.DexeroCoreApp.getUserOptions();
    // TEXT OPS
    const { langObj = {} } = options;
    const {
      invalidFileTypeText,
      invalidFileSizeText,
      invalidListItemText,
      fieldRequiredText,
      fieldInvalidText,
    } = langObj;

    const $form = $(this);
    const error = $form.siblings('.note-warning');
    const success = $form.siblings('.note-success');
    const fieldSuffix = $form.data('suffix') || '';
    const $fieldSubFormHiddenRequireInput = $('input.subFormRequired', $form);
    const $submitButton = $('button[type="submit"]', $form);
    const $fileInputs = $('input:file:not(.images-only):not(.note-image-input)', $form);
    const $signatureFields = $('.signature-field', $form);
    const $datePickerInputs = $('input.accessible-datepicker-input', $form);
    const $emailFields = $('.email-field');
    const $gRecaptchaInvisibleFields = $('.g-recaptcha-invisible-input');
    const $imageFileInputs = $('input:file.images-only', $form);
    const $equalToInputs = $('.input-equal-to', $form);
    const $autoCompleteInputs = $('input.autocomplete-field.must-match', $form);
    const $emptyWarningFields = $('[data-empty-warning="true"]', $form);
    const _formEmptyWarningMsg =
      typeof window.formEmptyWarningMsg === 'undefined'
        ? 'Empty warning message missing.'
        : window.formEmptyWarningMsg;

    // If validator is already attached, return
    if (typeof $form.data('validator') === 'object') {
      return;
    }

    $form.validate({
      debug: false,
      errorClass: 'has-error',
      errorElement: 'error-block', // default input error message container
      focusInvalid: false, // focus the last invalid input
      ignore:
        ':hidden:not(.required-hidden), .ignore-for-validation, .note-image-url, .note-link-text, .note-link-url, .note-video-url ', // do not validate these
      validClass: 'has-success',

      /* onkeyup: function(element) {
        // Disable keyup validation for specific elements
        if (!$(element).is(***INPUT ELEMENT***)) {
            $.validator.defaults.onkeyup.apply(this, arguments);
        }
        console.log(element);
      }, */

      onclick(element) {
        const $element = $(element);
        if (!$element.is('select')) {
          $element.valid();
        }
      },

      onfocusout(element) {
        const $element = $(element);
        if ($element.is('select')) {
          $element.valid();
        }
      },

      invalidHandler(event, validator) {
        // display error alert on form submit
        $(success).addClass('hide');
        $(error).removeClass('hide');
        // Reset submit button / Show errors to user
        window.DexeroCoreApp.animateButton($submitButton, undefined, true);
        if (!validator.numberOfInvalids()) {
          return;
        }
        // Scroll to first invalid element and focus on it
        const $firstInvalid = $(validator.errorList[0].element);
        if ($firstInvalid.is(':hidden')) {
          ($firstInvalid.closest('.form-group') as any).scrollTo(-20, true);
        } else {
          ($firstInvalid as any).scrollTo(-20, true);
        }
      },

      errorPlacement(_error, element) {
        // render error placement for each input type
        const $element = $(element);
        const elementName = getElementName(element);
        const $formGroup = $(`#row_${elementName}`);
        const $errorBlock = $formGroup.find(`#error_block_${elementName}`);
        const elementMsgInvalid =
          $element.attr('data-msg-invalid') !== undefined ? $element.data('msg-invalid') : false;
        const elementMsgRequired =
          $element.attr('data-msg-required') !== undefined ? $element.data('msg-required') : false;
        const elementMsgWarning =
          $element.attr('data-msg-warning') !== undefined ? $element.data('msg-warning') : false;
        const fieldId =
          fieldSuffix !== ''
            ? String($formGroup.data('field-id')).replace(fieldSuffix, '')
            : $formGroup.data('field-id');
        const myField = window.DexeroCoreApp.getFieldProperties(fieldId, fieldSuffix);
        const myFieldInvalidMsg =
          typeof myField === 'object' && myField !== null ? myField.msgInvalid : '';

        let message = '';
        if (elementMsgRequired) {
          message = elementMsgRequired;
        } else if (typeof myField === 'object' && myField !== null) {
          message = myField.msgRequired;
        }

        if (
          element.is($imageFileInputs) ||
          element.is($fileInputs) ||
          element.is($autoCompleteInputs) ||
          element.is($equalToInputs) ||
          element.is($signatureFields) ||
          element.is($datePickerInputs)
        ) {
          message = _error.text();
        } else if (element.is($emailFields) && $element.val()) {
          message = elementMsgInvalid || myFieldInvalidMsg;
        } else if (element.is($emptyWarningFields)) {
          message = elementMsgWarning || _formEmptyWarningMsg;
        }

        // if(message === '') {
        //   console.log('WARNING: Required Message Undefined!');
        //   console.log($(element));
        //   console.log(fieldId, fieldSuffix);
        //   console.log(myField);
        //   console.log('-----');
        // }

        $errorBlock.empty().html(message).removeClass('hide').attr('aria-hidden', 'false');
      },

      highlight(element) {
        // highlight error inputs
        const cls = $(element).is($emptyWarningFields) ? 'has-warning' : 'has-error';
        const elementName = getElementName(element);
        const $formGroup = $(`#row_${elementName}`);
        $formGroup.removeClass('has-success').addClass(cls); // set error class to the control group
      },

      unhighlight(element: HTMLInputElement) {
        // revert the change done by highlight
        const $element = $(element);
        const elementName = getElementName(element);
        const { name, type } = element;
        const $formGroup = $(`#row_${elementName}`);
        // const label = $(formGroup).find('label');
        const $errorBlock = $formGroup.find(`#error_block_${elementName}`);
        const $warningIcon = $formGroup.find('.tooltip-warning');

        function elementHasValue($elm: JQuery<HTMLInputElement>) {
          if (type === 'radio' || type === 'checkbox') {
            return $form.find(`[name="${name}"]`).filter(':checked').val();
          }
          return $elm.val();
        }

        $formGroup.removeClass('has-error has-warning').addClass('has-success'); // set error class to the control group
        $errorBlock.addClass('hide').attr('aria-hidden', 'true');
        // Reset warning elements. If a user enters info into a warning field, but then later removes it again, we need to reset the warnings to show
        if ($element.is($emptyWarningFields) && elementHasValue($element)) {
          $warningIcon.remove();
          $element
            .removeData('empty-warning')
            .attr('data-empty-warning', 'true')
            .data('empty-warning', true);
        }
      },

      success(label, element) {
        const elementName = getElementName(element);
        const $formGroup = $(`#row_${elementName}`);
        const $errorBlock = $formGroup.find(`#error_block_${elementName}`);
        $formGroup.removeClass('has-error has-warning').addClass('has-success');
        $errorBlock.addClass('hide').attr('aria-hidden', 'true'); // set success class to the control group
      },

      submitHandler() {
        $(success).removeClass('hide');
        $(error).addClass('hide');
        window.DexeroCoreApp.animateButton($submitButton);

        return true;
      },
    });

    $emptyWarningFields.each((_, elm) => {
      $(elm).rules('add', {
        emptyWarning: true,
      });
    });

    $emailFields.each((_, elm) => {
      $(elm).rules('add', {
        emailStrict: true,
      });
    });

    $gRecaptchaInvisibleFields.each((_, elm) => {
      $(elm).rules('add', {
        reCaptchaCheck: true,
      });
    });

    $autoCompleteInputs.each((_, elm) => {
      const $input = $(elm);
      const name = $input.attr('name');
      const $formGroup = $(`#row_${name}`);
      const fieldId =
        fieldSuffix !== ''
          ? $formGroup.data('field-id').replace(fieldSuffix, '')
          : $formGroup.data('field-id');
      const myField = window.DexeroCoreApp.getFieldProperties(fieldId, fieldSuffix);
      const _fieldRequiredText =
        typeof myField !== 'object' || myField === null ? fieldRequiredText : myField.msgRequired;

      $input.rules('add', {
        autoCompleteCheck: true,
        messages: {
          autoCompleteCheck: invalidListItemText,
          required: _fieldRequiredText,
        },
      });
    });

    $datePickerInputs.each((_, elm) => {
      const $input = $(elm);
      const name = $input.attr('name');
      const $formGroup = $(`#row_${name}`);
      const fieldId =
        fieldSuffix !== ''
          ? $formGroup.data('field-id').replace(fieldSuffix, '')
          : $formGroup.data('field-id');
      const myField = window.DexeroCoreApp.getFieldProperties(fieldId, fieldSuffix);
      const _fieldRequiredText =
        typeof myField !== 'object' || myField === null ? fieldRequiredText : myField.msgRequired;
      const _fieldInvalidText =
        typeof myField !== 'object' || myField === null ? fieldInvalidText : myField.msgInvalid;
      const _fieldMsgWarning =
        $input.attr('data-msg-warning') !== undefined
          ? $input.data('msg-warning')
          : _formEmptyWarningMsg;

      $input.rules('add', {
        allowedDate: true,
        messages: {
          allowedDate: _fieldInvalidText,
          emptyWarning: _fieldMsgWarning,
          required: _fieldRequiredText,
          strictValidDate: _fieldInvalidText,
        },
        strictValidDate: true,
      });
    });

    $fieldSubFormHiddenRequireInput.each((_, elm) => {
      $(elm).rules('add', {
        hasSubCardsCheck: true,
      });
    });

    $imageFileInputs.each((_, elm) => {
      const $input = $(elm);
      const name = $input.attr('name');
      const acceptedFiles =
        typeof $input.attr('accept') !== 'undefined'
          ? $input.attr('accept')
          : 'image/x-png, image/gif, image/jpeg, image/jpg, image/pjpeg, image/png';
      const fileSizeMB = $input.data('max-file-size');
      // One MB is 1048576 Bytes
      const fileSizeByte = (1048576 * Number(fileSizeMB)).toFixed(0);
      const $formGroup = $(`#row_${name}`);
      const fieldId =
        fieldSuffix !== ''
          ? $formGroup.data('field-id').replace(fieldSuffix, '')
          : $formGroup.data('field-id');
      const myField = window.DexeroCoreApp.getFieldProperties(fieldId, fieldSuffix);

      const _fieldRequiredText =
        typeof myField !== 'object' || myField === null ? fieldRequiredText : myField.msgRequired;

      $input.rules('add', {
        accept: acceptedFiles,
        filesize: fileSizeByte,
        messages: {
          accept: `${invalidFileTypeText} ${acceptedFiles}`,
          filesize: `${invalidFileSizeText} ${fileSizeMB}MB.`,
          required: _fieldRequiredText,
        },
      });
    });

    $signatureFields.each((_, elm) => {
      const $input = $(elm).siblings('input[type="hidden"]');
      const name = $input.attr('name');
      const $formGroup = $(`#row_${name}`);
      const fieldId =
        fieldSuffix !== ''
          ? $formGroup.data('field-id').replace(fieldSuffix, '')
          : $formGroup.data('field-id');
      const myField = window.DexeroCoreApp.getFieldProperties(fieldId, fieldSuffix);
      const _fieldRequiredText =
        typeof myField !== 'object' || myField === null ? fieldRequiredText : myField.msgRequired;

      $input.rules('add', {
        messages: {
          required: _fieldRequiredText,
          signatureCheck: _fieldRequiredText,
        },
        signatureCheck: true,
      });
    });

    $equalToInputs.each((_, elm) => {
      const $input = $(elm);
      const name = $input.attr('name');
      const equalToIdent = $input.data('equal-to');
      const equalToMessage = $input.data('msg-equalto');
      const equalTo = $(`input[name="${equalToIdent}"]`, $form);
      const $formGroup = $(`#row_${name}`);
      const fieldId =
        fieldSuffix !== ''
          ? $formGroup.data('field-id').replace(fieldSuffix, '')
          : $formGroup.data('field-id');
      const myField = window.DexeroCoreApp.getFieldProperties(fieldId, fieldSuffix);
      const _fieldRequiredText =
        typeof myField !== 'object' || myField === null ? fieldRequiredText : myField.msgRequired;

      $input.rules('add', {
        equalTo,
        messages: {
          equalTo: equalToMessage,
          required: _fieldRequiredText,
        },
      });
    });

    $fileInputs.each((_, elm) => {
      const $input = $(elm);
      const name = $input.attr('name');
      const fileSizeMB = $input.data('max-file-size');
      // One MB is 1048576 Bytes
      const fileSizeByte = (1048576 * Number(fileSizeMB)).toFixed(0);
      const $formGroup = $(`#row_${name}`);
      const fieldId =
        fieldSuffix !== ''
          ? $formGroup.data('field-id').replace(fieldSuffix, '')
          : $formGroup.data('field-id');
      const myField = window.DexeroCoreApp.getFieldProperties(fieldId, fieldSuffix);
      const _fieldRequiredText =
        typeof myField !== 'object' || myField === null ? fieldRequiredText : myField.msgRequired;

      $input.rules('add', {
        filesize: fileSizeByte,
        messages: {
          filesize: `${invalidFileSizeText} ${fileSizeMB}MB.`,
          required: _fieldRequiredText,
        },
      });
    });
  });
}
